export default __webpack_public_path__ + "static/media/float_inerit.70f4ac9d.svg";